<template>
    <div>

        <v-row>
            <v-col>
                <datePickerForm
                    label="Fecha"
                    :valueInput="values.date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                    :errorMessages="serverErrors['date']"
                    :disabled="true"
                ></datePickerForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Cliente"
                    :loading="loadingClients"
                    :valueInput="values.receiver_id"
                    :rule="rules.required"
                    :items="serverItems.clients"
                    :errorMessages="serverErrors.receiver_id"
                    @valueChange="(v) => {values.receiver_id = v; delete serverErrors.receiver_id}"
                    :disabled="true"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="OT"
                    :loading="loadingReferences"
                    :valueInput="values.reference_id"
                    :rule="rules.required"
                    :items="serverItems.references"
                    :errorMessages="serverErrors.reference_id"
                    @valueChange="(v) => {values.reference_id = v; delete serverErrors.reference_id}"
                    :disabled="true"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2" cols="12" md="6">
                <autocompleteOneForm
                    label="Tipo de cuenta"
                    :valueInput="values.type"
                    :rule="rules.required"
                    :items="serverItems.types"
                    :errorMessages="serverErrors.type"
                    @valueChange="(v) => {values.type = v; delete serverErrors.type}"
                ></autocompleteOneForm>
            </v-col>

            <v-col class="py-2">
                <autocompleteOneForm
                    label="Límite de crédito en días"
                    :valueInput="values.credit_period"
                    :rule="rules.required"
                    :items="serverItems.credit_period"
                    :errorMessages="serverErrors.credit_period"
                    @valueChange="(v) => {values.credit_period = v; delete serverErrors.credit_period}"
                ></autocompleteOneForm>
            </v-col>

        </v-row>

        <v-row>
            <v-col class="py-2" cols="12">
                <autocompleteOneForm
                    :loading="loadingConcepts"
                    label="Concepto"
                    :valueInput="values.concept_id"
                    :rule="rules.required"
                    :items="serverItems.concepts"
                    :errorMessages="serverErrors.concept_id"
                    @valueChange="(v) => {values.concept_id = v; delete serverErrors.concept_id}"
                ></autocompleteOneForm>
            </v-col>

           

        </v-row>

        <v-row>
             <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.comments = v; delete serverErrors.comments}" 
                    :valueInput="values.comments" 
                    :rule="[]" 
                    label="Comentarios"
                    :errorMessages="serverErrors.comments"
                ></textFieldForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-0">
                <h4>Partidas</h4>
            </v-col>
        </v-row>

     


        <v-row key="keyTable">
            <v-col>
                <table-items  :props="tableProps" @methodHandler="method_handler" :items="values.items">
                   
                    

                    <template v-slot:item.unit_price="props">
                        <div class="table-item">
                            <span>{{ut.currencyFormat(props.item.unit_price, values.currency)}}</span>
                        </div>
                    </template>

                    <template v-slot:item.iva="props">
                        <div class="table-item">
                            <div v-for="(item, index) in props.item.taxes" :key="index" class="">
                                <div class="sale-bill-tax-item px-3">
                                    <p class="mb-0 font-weight-bold">{{item.name}} ({{ut.getPercentage(item.rate, 1)}}%)</p>
                                    <p class="mb-0">{{ut.currencyFormat(item.total, values.currency)}}</p>
                                </div>
                               
                            </div>
                            
                        </div>
                    </template>

                    <template v-slot:item.total="props">
                        <div class="table-item">
                            <span>{{ut.currencyFormat(props.item.total, values.currency)}}</span>
                        </div>
                    </template>
                   
                </table-items>
                <!-- <v-input class="warning--text caption" :error-messages="serverErrors.balanceables" v-model="values.balanceables" :rules="rules.balanceables"></v-input> -->
            </v-col>
        </v-row>
        
        






    </div>
</template>

<script>
import TableItems from "../incomes/TableItems.vue";
import Utils from '../../helpers/Utils';

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'inputCreditNotes'],
    components: {
       'table-items': TableItems
    },
    data(){
        return {
            keyTable: 4443,
            ut: Utils,
            loadingClients: false,
            loadingReferences: false,
            loadingConcepts: false,
           
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
               
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],

                requiredIva: [
                    v => {
                        if(this.values.ObjetoImp == 2)
                            return 'El campo es requerido'
                        return true;
                    }
                ],
               
				current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        if(v === 0 || v === '0' || v<=0)
                            return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
            },
            serverItems: {
                concepts:[ 
                ],
                references:[ 
                ],
                products:[ 
                ],
                paymentForms:[ 
                ],
                cfdiTypes:[ 
                ],
                paymentsMethods:[ 
                ],
                clients: [
                ],
                iva: [
                    {text: "IVA 16%", value:"0.16"},

                ],
                types: [
                    //  NORMAL, ANTICIPADA, COTIZACIÓN, SERVICIOS, CONTADO, CRÉDITO
                    { text: "NORMAL", value: "NORMAL" },
                    { text: "ANTICIPADA", value: "ANTICIPADA" },
                    { text: "COTIZACIÓN", value: "COTIZACIÓN" },
                    { text: "SERVICIOS", value: "SERVICIOS" },
                    { text: "CONTADO", value: "CONTADO" },
                    { text: "CRÉDITO", value: "CRÉDITO" },
                ],
                credit_period:[
                    {text: "0 DÍAS", value: '0'},
                    {text: "7 DÍAS", value: 7},
                    {text: "15 DÍAS", value: 15},
                    {text: "30 DÍAS", value: 30},
                    {text: "60 DÍAS", value: 60},
                    {text: "90 días", value: 90}
                ],
            },

           
			tableProps: {
				headers: [
                     {
						text: 'Producto',
						align: 'left small-th-always',
						value: 'id_product',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'Cant.',
						align: 'left small-th-always',
						value: 'quantity',
						sortable: false,
                       
						class: 'table-b-border black--text'
					},
                    {
						text: 'Unidad',
						align: 'left small-th-always',
						value: 'unitText',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Concepto',
						align: 'left small-th-always',
						value: 'description',
						sortable: false,
						class: 'table-b-border black--text'
					},
                     {
						text: 'P.U.',
						align: 'right small-th-always',
						value: 'unit_price',
                        width: '10%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Impuestos',
						align: 'center small-th-always',
						value: 'iva',
						sortable: false,
                        width: '15%',
						class: 'table-b-border black--text'
					},
                     {
						text: 'Importe',
						align: 'right small-th-always',
						value: 'total',
						sortable: false,
                        width: '10%',
						class: 'table-b-border black--text'
					},
					
				],
				items: this.values.items,
				search: '',
				loading: false,
                keyValue: 0,
			},

          
        }
    },
    computed: {
        
    },
    watch: { 

        
    },
    mounted(){
        
        this.getCustomers();
        this.getReferences();
        this.getConcepts();

        this.loadItems();
      
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},

        loadItems(){
            // let item = {
            //     "id_product": data.Folio,
            //     "description": data.Description,
            //     "tax_object": data.ObjetoImp,
            //     "unit_code": data.UnitCode,
            //     "unit_price": data.Price,
            //     "quantity": 1,
            //     "subtotal": data.Price,
            //     "discount": 0.0,
            //     "unitText": `${data.UnitCode} - ${data.Unit}`,
            //     "isTaxItem": this.checkTax(data.ObjetoImp),
            //     "taxes": [
                
            //     ],
            //     "total": data.Price,
            //     actions : JSON.parse(JSON.stringify(this.actions)),
            //     parameters: { id: data.Folio },
            // }

            this.values.items.forEach(item => {
                item[`unitText`] = `${item.unit_code} - ${item.unit}`;
                item[`unit`] = item.unit;
                item[`isTaxItem`] = this.checkTax(item.tax_object);
            });

            this.keyTable = this.keyTable + 1
            this.tableProps.keyValue = this.tableProps.keyValue + 1
        },

        calcItem(item){
            item.subtotal = item.unit_price * item.quantity;

            //process taxes
            item = this.processTaxes(item);

            console.log(item)
            return item;
        },
        processTaxes(item){
            item.total = item.subtotal;
            if(!item.isTaxItem) return item;

            item.taxes.forEach(tax => {
                console.log("si entra")
                if(tax.name == 'IVA'){
                    
                    tax.total = Utils.getIvaValue(item.subtotal, tax.rate);
                    tax.base = parseFloat(item.subtotal).toFixed(2);
                    item.total = parseFloat(item.total) + parseFloat(tax.total+"")
                    item.total = item.total.toFixed(2);

                    console.log(item)
                }
            });


            return item;
        },

        

        
        calcItemTotal(item){
            let iva = 0;
            let prodPrice = item.Price * item.quantity;
            if(this.checkTax(item.ObjetoImp)){
                iva = Utils.getIvaValue(data.Price, data.IVA) * item.quantity;
            }

            return prodPrice + iva;

        },

        checkTax(value){
          
            const numValue = parseInt(value);
            switch (numValue) {
                case 1:
                case 4:
                case 7:
                case 8:
                    return false;
                default:
                    return true;
            }
        },

        getConcepts()
        {
            this.loadingConcepts = true;
            this.$api.concept.getSelectConcepts(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.concepts = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingConcepts = false;
                })
            ;
        },

        getCustomers()
        {
            this.loadingClients = true;
            this.$api.customer.getSelectCustomers(this.$store.state.business)
				.then((resp) =>{
					this.serverItems.clients = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingClients = false;
				})
			;
        },

        getReferences()
        {
            this.loadingReferences = true;
            this.$api.reference.getSelectReferences(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.references = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingReferences = false;
                })
            ;
        },


       
    }
}
</script>

<style lang="scss">
    .sale-bill{
        &-form-product-select-container{
            display: flex;
            width: 100%;

        }

        &-tax-item{
            margin: .5rem 0;
            display: flex;
            flex-direction: column;
            border: solid 1px var(--v-line-base);
            align-items: center;
            border-radius: .3rem;
            
        }

        &-tax-container{
            padding: 1px 5px;
            background-color: var(--v-inputsBackground-base);
        }

        &-tax-value{

        }
    }
</style>